<template>
  <div class="home">
    <h3>Data Pendaftaran Wisuda</h3>

    <div class="card">
      <div class="card-body">
        <p style="font-size: 14px">Filter Data</p>
        <form @submit.prevent="filterData" class="form-filter">
          <input type="text" placeholder="Cari Nama / No Daftar..." v-model="filter.nama" />
          <button type="submit" class="btn-primary">CARI</button>
        </form>

        <button type="button" class="btn-excel" @click="exportExcel">
          Export Excel
        </button>

        <div class="table-block">
          <table class="table" id="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Angkatan</th>
                <th>No Daftar</th>
                <th>Prodi</th>
                <th>Nama Siswa</th>
                <th>No Telp Siswa</th>
                <th v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  Nama Pendamping
                </th>
                <th v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  No Telp Pendamping
                </th>
                <th v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  Status Bayar
                </th>
                <th>No Kursi</th>
                <th v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  {{ $route.params.status == "reject" ? "Alasan Ditolak" : "" }}
                </th>
                <th v-if="$route.params.status == 'toga_deposit'">
                  Ambil Deposit
                </th>
                <th v-if="$route.params.status == 'toga_deposit'">
                  Ambil Toga
                </th>
                <th v-if="$route.params.status == 'checkin'">Waktu Checkin</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, k) in data" :key="k" :class="item.is_validated == 1 ? 'valid' : ''"
                @click="openDetail(item)" style="cursor: pointer">
                <td>{{ k + 1 }}</td>
                <td>{{ item.angkatan_2 }}</td>
                <td>{{ item.no_daftar }}</td>
                <td>{{ item.jurusan }}</td>
                <td>{{ item.nama_lengkap }}</td>
                <td>{{ item.no_hp }}</td>
                <td v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  {{ item.nama_pendamping_1 }}
                </td>
                <td v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  {{ item.no_hp_pendamping_1 }}
                </td>
                <td v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  {{ item.status_bayar }}
                </td>
                <td>
                  {{ item.no_kursi ? item.no_kursi.padStart(3, "0") : "-" }}
                </td>
                <td v-if="
                  $route.params.status != 'toga_deposit' &&
                  $route.params.status != 'checkin'
                ">
                  <div v-if="$route.params.status == 'reject'">
                    {{ item.alasan_ditolak }}
                  </div>
                  <div v-else>
                    <span v-if="item.is_validated != 1">
                      Belum Divalidasi
                    </span>

                    <span v-if="item.is_validated == 1">Sudah Divalidasi</span>
                  </div>
                </td>
                <td v-if="$route.params.status == 'toga_deposit'">
                  {{
                    moment(item.waktu_ambil_deposit).format("DD-MM-YYYY HH:mm")
                  }}
                </td>
                <td v-if="$route.params.status == 'toga_deposit'">
                  {{ moment(item.waktu_ambil_toga).format("DD-MM-YYYY HH:mm") }}
                </td>
                <td v-if="$route.params.status == 'checkin'">
                  {{ moment(item.waktu_checkin).format("HH:mm") }}
                </td>
              </tr>
              <tr v-if="data.length <= 0">
                <td colspan="10">
                  <p style="
                      text-align: center;
                      padding: 100px 0;
                      font-size: 14px;
                    ">
                    Data tidak ditemukan
                  </p>
                </td>
              </tr>
            </tbody>
          </table>

          <div style="margin-top: 100px" v-show="loading">
            <p style="text-align: center">
              <loading />
              <br /><br />
              Loading data...
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" v-if="modalOpen" @click="closeModal">
      <div class="modal-body">
        <div class="modal-close">
          <div @click="modalOpen = false">
            <close />
          </div>
        </div>
        <table>
          <tr>
            <td style="width: 120px">NAMA LENGKAP</td>
            <td>:</td>
            <td>{{ selectedSiswa.nama_lengkap }}</td>
          </tr>
          <tr>
            <td>NO DAFTAR</td>
            <td>:</td>
            <td>{{ selectedSiswa.no_daftar }}</td>
          </tr>
          <tr>
            <td>KAMPUS</td>
            <td>:</td>
            <td>{{ selectedSiswa.kampus }}</td>
          </tr>
          <tr>
            <td>ANGKATAN</td>
            <td>:</td>
            <td>{{ selectedSiswa.angkatan_2 }}</td>
          </tr>
        </table>

        <ul class="tab-nav">
          <li :class="{ active: tab == 'edit' }" @click="tab = 'edit'">
            Edit Data
          </li>
          <li :class="{ active: tab == 'bukti' }" @click="tab = 'bukti'">
            Bukti Bayar
          </li>
        </ul>

        <div v-show="tab == 'edit'">
          <form @submit.prevent="updateData">
            <p style="color: #007bff">Update Data</p>
            <table>
              <tr>
                <td style="width: 140px">No Telp Siswa</td>
                <td>:</td>
                <td>
                  <input type="text" v-model="selectedSiswa.no_hp" />
                </td>
              </tr>
              <tr>
                <td>Nama Pendamping</td>
                <td>:</td>
                <td>
                  <input type="text" v-model="selectedSiswa.nama_pendamping_1" />
                </td>
              </tr>
              <tr>
                <td>No Telp Pendamping</td>
                <td>:</td>
                <td>
                  <input type="text" v-model="selectedSiswa.no_hp_pendamping_1" />
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td style="padding-top: 10px" align="right">
                  <button type="button" class="btn btn-outline" @click="edit = false">
                    Batal
                  </button>
                  <button type="submit" class="btn btn-primary" :disabled="btnLoadingUpdate">
                    {{ btnLoadingUpdate ? "Updating..." : "Update Data" }}
                  </button>
                </td>
              </tr>
            </table>
          </form>
        </div>

        <div v-show="tab == 'bukti'">
          <p style="color: #007bff">Bukti Pembayaran</p>
          <div class="bukti-bayar">
            <p v-if="!selectedSiswa.bukti_bayar">Belum ada bukti bayar</p>
            <img :src="selectedSiswa.bukti_bayar" width="100%" />
          </div>

          <div v-if="!selectedSiswa.is_validated && this.$user.access == 'ADMIN'">
            <button type="button" @click="confirmValidasi(selectedSiswa)" class="btn">
              Validasi
            </button>
            <button type="button" class="btn btn-tolak" @click="tolakValidasi(selectedSiswa)">
              Tolak
            </button>
          </div>

          <div v-if="selectedSiswa.alasan_ditolak">
            <p>Alasan Ditolak:</p>
            <div>
              <small>{{ selectedSiswa.alasan_ditolak }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading" v-show="loading">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import Close from "./icons/Close.vue";
import Options from "./icons/Options.vue";
import Loading from "./icons/Loading.vue";
import Download from "./icons/Download.vue";

import moment from "moment";
import * as api from "../api/Api";

export default {
  name: "Sertifikat",
  components: {
    Close,
    Options,
    Loading,
    Download,
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      popoverOpen: false,
      modalOpen: false,
      file: null,
      data: [],
      tmpData: [],
      siswa: {},
      filter: {
        nama: "",
        no_daftar: "",
        status: "",
        id_kampus: -1,
      },
      openDitolak: false,
      selectedSiswa: {},
      edit: false,
      btnLoadingUpdate: false,
      tab: "bukti",
      checklist: [],
    };
  },
  props: {
    id_kampus: String,
    angkatan: String,
  },
  methods: {
    moment,
    togglePopover() {
      this.popoverOpen = !this.popoverOpen;
    },
    closePopover() {
      this.popoverOpen = false;
    },
    openDetail(item) {
      // if (this.$user.access == "ADMIN") {
      this.edit = false;
      this.selectedSiswa = item;
      this.modalOpen = true;
      // }
    },
    closeModal(e) {
      if (e.target.classList[0] == "modal") {
        this.modalOpen = false;
      }
    },
    confirmValidasi(item) {
      if (
        confirm("Validasi " + item.nama_lengkap + " / " + item.no_daftar + " ?")
      ) {
        api
          .post("/v1/wisuda/PendaftaranController/validate", {
            id: item.id,
          })
          .then((r) => {
            this.modalOpen = false;
            this.loadData();
          })
          .catch((e) => {
            this.modalOpen = false;
            alert("Server Error");
          });
      }
    },
    tolakValidasi(siswa) {
      const alasan = prompt("Input alasan ditolak");
      if (!alasan) {
        alert("Alasan harus diisi");
        return;
      }

      const data = {
        id: siswa.id,
        alasan: alasan,
      };

      api
        .post("/v1/wisuda/PendaftaranController/reject", data)
        .then((r) => {
          this.modalOpen = false;
          this.loadData();
        })
        .catch((e) => {
          this.modalOpen = false;
          alert("Server Error");
        });
    },
    loadData() {
      let param = "status=" + this.$route.params.status + "&";

      if (this.$user.access != "ADMIN") {
        param += "id_kampus=" + this.$user.id_kampus;
      }
      if (this.id_kampus != -1) {
        param += "id_kampus=" + this.id_kampus;
      }
      if (this.angkatan) {
        param += "&angkatan=" + this.angkatan;
      }

      this.loading = true;

      api
        .get("/v1/wisuda/PendaftaranController/getPeserta?" + param)
        .then((r) => {
          setTimeout(() => {
            this.loading = false;

            this.data = r.data;
            this.tmpData = r.data;
          }, 150);
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    filterData() {
      if (this.filter.nama) {
        this.data = this.tmpData.filter((item) => {
          if (item.nama_lengkap) {
            return (
              item.nama_lengkap.toLowerCase().indexOf(this.filter.nama) > -1 ||
              item.no_daftar.indexOf(this.filter.nama) > -1
            );
          }
        });
      } else {
        this.data = this.tmpData;
      }
    },
    updateData() {
      this.btnLoadingUpdate = true;
      api
        .post("/v1/wisuda/PendaftaranController/updateData", this.selectedSiswa)
        .then((r) => {
          this.btnLoadingUpdate = false;

          this.modalOpen = false;
          this.loadData();
        })
        .catch((e) => {
          this.btnLoadingUpdate = false;

          this.modalOpen = false;
          alert("Server Error");
        });
    },
    exportExcel() {
      let param = "status=" + this.$route.params.status + "&";

      if (this.$user.access != "ADMIN") {
        param += "id_kampus=" + this.$user.id_kampus;
      }
      if (this.filter.id_kampus != -1) {
        param += "id_kampus=" + this.filter.id_kampus;
      }

      location.href =
        "https://api.pspp-integrated.com/api/v1/wisuda/PendaftaranController/download?" +
        param;
    },
    toggleCheckList(value) { },
  },
  mounted() {
    this.loadData();
    this.filter.status = this.$route.params.status.toUpperCase();
  },
  watch: {
    angkatan(val) {
      this.loadData();
    },
    id_kampus(val) {
      this.loadData();
    },
    $route(to) {
      this.filter.status = to.params.status.toUpperCase();
      this.loadData();
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  padding: 15px 15px 0px 15px;

  h3 {
    margin: 0 0 15px;
  }

  .navbar {
    display: flex;
    justify-content: space-between;

    a {
      color: #333;
      text-decoration: none;
      display: flex;
      align-items: center;

      .icon {
        margin-left: 5px;
        width: 20px;
      }
    }
  }

  .card {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 4px #999;

    .card-filter {
      display: flex;
      justify-content: flex-end;
      padding: 15px;
      text-align: right;
      position: relative;

      .popup {
        position: absolute;
        background: #fff;
        padding: 15px;
        border: 1px solid #ccc;
        border-radius: 6px;
        margin-top: 50px;
        margin-right: 140px;
        text-align: left;
        box-shadow: 0px 20px 40px #bbb;
      }
    }

    .card-body {
      padding: 0px 20px;
      height: calc(100vh - 140px);
      display: block;
      overflow: auto;

      .form-filter {
        display: grid;
        grid-template-columns: 250px 100px;
        grid-column-gap: 15px;
        margin-bottom: 15px;
      }
    }
  }

  .table-block {
    height: calc(100vh - 250px);
    overflow: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    thead {
      th {
        background-color: #eee;
        padding: 8px;
        text-align: left;
        text-transform: uppercase;
        white-space: nowrap;
        position: sticky;
        top: 0;
      }
    }

    tbody {
      tr:hover {
        td {
          background-color: #f7f7f7;
        }
      }

      td {
        padding: 10px;
        text-align: left;
        border-bottom: 1px solid #eee;
        vertical-align: top;
      }

      tr.valid {
        td {
          background-color: #e7f7e9;
        }

        &:hover {
          td {
            background-color: #d2e6d4;
          }
        }
      }
    }
  }

  .badge-pending {
    font-size: 12px;
    background-color: #ffe600;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .badge-dikirim {
    font-size: 12px;
    background-color: #b3ff00;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .badge-validasi {
    font-size: 12px;
    background-color: #03ebb8;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .badge-ditolak {
    font-size: 12px;
    background-color: #eb3103;
    color: #fff;
    padding: 4px 12px;
    border-radius: 4px;
    width: 60px;
    display: block;
    text-align: center;
  }

  .form {
    .form-group {
      margin-bottom: 15px;

      label {
        display: block;
        margin-bottom: 5px;
        font-size: 14;
      }

      p {
        margin-top: 5px;
        font-weight: 600;
      }
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .modal-body {
      margin-top: 70px;
      background: #fff;
      border-radius: 6px;
      padding: 20px;
      width: 450px;
      max-height: 70vh;
      overflow-y: auto;

      .modal-close {
        position: relative;
        height: 20px;

        .icon {
          position: absolute;
          right: -10px;
          top: -10px;
          width: 30px;
          cursor: pointer;
        }
      }

      .bukti-bayar {
        height: 400px;
        margin-bottom: 15px;
        overflow: auto;
        border: 1px solid #ccc;

        p {
          text-align: center;
          line-height: 300px;
        }
      }

      table {
        td {
          font-size: 14px;
        }
      }
    }
  }

  .btn {
    padding: 10px 15px;
    text-align: center;
    text-transform: uppercase;

    &:disabled {
      background: #5dabff;
    }

    &.btn-update {
      background: #fff;
      border: 1px solid #007bff;
      color: #007bff;
    }

    &.btn-tolak {
      background: #fff;
      border: 1px solid #f00;
      color: #f00;
    }
  }

  .vue-daterange-picker {
    display: block;
  }

  .btn-excel {
    position: absolute;
    right: 40px;
    margin-top: -50px;
    background: #28a745;
    padding: 10px 15px;
    text-transform: uppercase;
    transition: all 0.3 ease;

    &:hover {
      background: #1f8a38;
    }

    &:active {
      background: #28a745;
    }
  }

  input[type="checkbox"] {
    transform: scale(1.5);
    cursor: pointer;
  }

  .btn-validasi {
    color: #007bff;
    display: block;
    cursor: pointer;
    padding: 10px;

    &:hover {
      text-decoration: underline;
    }
  }

  .btn-outline {
    background-color: #fff;
    border: 1px solid red;
    color: red;
  }

  .tab-nav {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;

    li {
      display: block;
      cursor: pointer;
      padding: 5px 15px;
      border-radius: 5px;

      &:hover,
      &.active {
        background: #007bff;
        color: #fff;
      }
    }
  }
}

.loading {
  position: fixed;
  top: 0;
  left: 200px;
  width: calc(100% - 200px);
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #333;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
}
</style>
<style>
.reportrange-text {
  padding: 10px !important;
  border-radius: 4px !important;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Wisuda.vue